/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import DomEventsManager from 'scripts/dom-events-manager';

export var MediaFeed = BaseControl.extend({
    init: function() {
        this._super();
        DomEventsManager.subscribe(this);
        this.$swiperContainer = this.$element.find('.swiper-container');
    },

    onLayout(screen) {
        if (screen === 'small' || screen === 'extra-small') {
            this.initSwiper();
        }
    },

    initSwiper() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }

        this.swiper = new Swiper(this.$swiperContainer, {
            simulateTouch: true,
            slidesPerView: 2,
            speed: 1000,
            pagination: {
                el: this.$swiperContainer.find('.swiper-pagination'),
                clickable: true,
            },
        });
    },
});
